"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _commonI18n = require("@mmc/common-i18n");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _text = require("@mmc/text");
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _navigationHeader = _interopRequireDefault(require("../styles/navigation-header.css"));
var _lazyNavLinkImage = _interopRequireDefault(require("./lazy-nav-link-image"));
var dataUtils = new _mmcDataUtilities["default"]();
var isEmptyArray = dataUtils.isEmptyArray,
  handleNestedProp = dataUtils.handleNestedProp,
  appendImageOptimization = dataUtils.appendImageOptimization,
  formatAsMKSPath = dataUtils.formatAsMKSPath;
var prepareProductForDataLayer = function prepareProductForDataLayer(product, currencyFormat) {
  if (product) {
    var clonedProduct = JSON.parse(JSON.stringify(product));
    if (clonedProduct.cta && clonedProduct.cta.url) {
      clonedProduct.cta.url = formatAsMKSPath(clonedProduct.cta.url);
    }
    if (clonedProduct.price) {
      clonedProduct.price.currency = currencyFormat;
    }
    return clonedProduct;
  }
  return product;
};
var getBackgroundImage = function getBackgroundImage(checkedLink, link) {
  var imageWidth = 480;
  var imageSrc = handleNestedProp(link, 'checkedLink.vehicleBackgroundImage.image');
  var isBackground = false;
  var isWebp = true;
  var imageQuality = 70;
  return checkedLink.vehicleBackgroundImage && (checkedLink.vehicleImage === ' ' || checkedLink.vehicleImage === null || checkedLink.vehicleImage === undefined) && /*#__PURE__*/_react["default"].createElement("div", {
    className: _navigationHeader["default"].navLinkImage
  }, /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    src: "" + appendImageOptimization(imageSrc, imageWidth, isBackground, isWebp, imageQuality),
    srcSet: [appendImageOptimization(imageSrc, 320, isBackground, isWebp, imageQuality) + " 320w", appendImageOptimization(imageSrc, 480, isBackground, isWebp, imageQuality) + " 480w", appendImageOptimization(imageSrc, 640, isBackground, isWebp, imageQuality) + " 640w", appendImageOptimization(imageSrc, 720, isBackground, isWebp, imageQuality) + " 720w", appendImageOptimization(imageSrc, 1080, isBackground, isWebp, imageQuality) + " 1080w"].join(','),
    sizes: "(min-width: 768px) 30vw, 60vw",
    alt: handleNestedProp(link, 'link.vehicleBackgroundImage.altText'),
    width: imageWidth
  }));
};
var ProductLinks = function ProductLinks(_ref) {
  var products = _ref.products,
    theme = _ref.theme,
    totalSetSize = _ref.totalSetSize,
    name = _ref.name,
    addPriceDisclaimer = _ref.addPriceDisclaimer,
    priceDisclaimerId = _ref.priceDisclaimerId,
    disclaimerData = _ref.disclaimerData,
    market = _ref.market,
    config = _ref.config,
    currentPath = _ref.currentPath,
    keyHandlerMethod = _ref.keyHandlerMethod;
  var refList = {};
  var keyHandler = function keyHandler() {
    keyHandlerMethod.apply(void 0, arguments);
  };
  var checkDisclaimerID = function checkDisclaimerID(checkedSettings) {
    var disclaimerID = checkedSettings.disclaimerIdVehicleCard;
    var codeValue = disclaimerID && disclaimerID !== '' ? disclaimerID : handleNestedProp(checkedSettings, 'checkedSettings.priceDisclaimerId');
    return codeValue;
  };
  var publishMenuClickToDataLayer = function publishMenuClickToDataLayer(mainMenu, linkUrl, subMenu, market) {
    if ((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'menu_click',
        comp_page: {
          position: 'top menu',
          main_category: mainMenu ? mainMenu.toLowerCase() : null,
          selected_category: subMenu ? subMenu.toLowerCase() : null
        }
      });
      if (['/concesionarios', '/localizador-concessionarios', '/loyda-lahin-jalleenmyyjasi'].includes(linkUrl)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'dealer_locator_click',
          comp_page: {
            position: 'top menu'
          }
        });
      }
      if (['/comprar/configurador', '/loquiero/configurador', '/osta/rakenna-oma-mitsubishi', '/osta/rakenna-oma-mitsubishi/rakenna-autosi'].includes(linkUrl)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'car_configuration_click',
          comp_product: {
            position: 'top menu',
            vehicle_type: 'car',
            brand: 'mitsubishi',
            product_condition: 'new',
            model: null,
            version: null,
            color: null,
            upholstery: null,
            accesories: null,
            fuel_type: null,
            price: null,
            currency: null
          }
        });
      }
      if (['/servicio/citataller', '/omistajuus/varaa-huolto'].includes(linkUrl)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'maintenance_request_click',
          comp_product: {
            position: 'top menu',
            vehicle_type: 'car',
            brand: 'mitsubishi',
            product_condition: 'new',
            model: null,
            version: null,
            fuel_type: null,
            dealer_name: null
          }
        });
      }
      if (['/prueba', '/test-drive', '/varaa-koeajo'].includes(linkUrl)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'test_drive_request_click',
          comp_product: {
            position: 'top menu',
            vehicle_type: 'car',
            brand: 'mitsubishi',
            product_condition: 'new',
            model: null,
            version: null,
            fuel_type: null,
            dealer_name: null
          }
        });
      }
    }
  };
  var renderProductLink = function renderProductLink(settings) {
    var checkedSettings = {
      link: handleNestedProp(settings, 'settings.link'),
      i: handleNestedProp(settings, 'settings.i'),
      totalSetSize: handleNestedProp(settings, 'settings.totalSetSize'),
      name: handleNestedProp(settings, 'settings.name'),
      addPriceDisclaimer: handleNestedProp(settings, 'settings.addPriceDisclaimer'),
      priceDisclaimerId: handleNestedProp(settings, 'settings.priceDisclaimerId'),
      disclaimerData: settings.disclaimerData,
      enableProductsRatingStars: handleNestedProp(settings, 'settings.link.enableProductsRatingStars'),
      productSkuId: handleNestedProp(settings, 'settings.link.productSkuId'),
      disclaimerIdVehicleCard: handleNestedProp(settings, 'settings.link.disclaimerIdVehicleCard'),
      market: handleNestedProp(settings, 'settings.market')
    };
    var link = checkedSettings.link,
      enableProductsRatingStars = checkedSettings.enableProductsRatingStars,
      productSkuId = checkedSettings.productSkuId;
    var checkedLink = {
      vehicleBackgroundImage: handleNestedProp(link, 'link.vehicleBackgroundImage'),
      vehicleImage: handleNestedProp(link, 'link.vehicleImage'),
      price: handleNestedProp(link, 'link.price'),
      cta: handleNestedProp(link, 'link.cta'),
      label: handleNestedProp(link, 'link.name'),
      openNewTab: handleNestedProp(link, 'link.cta.openNewTab')
    };
    var label = checkedLink.label === ' ' || checkedLink.label === null || checkedLink.label === undefined ? handleNestedProp(link, 'link.cta.label') : checkedLink.label;
    var setSize = checkedSettings.totalSetSize;
    var posInSet = checkedSettings.i + 1;
    var name = checkedSettings.name + "_" + label;
    refList[name] = refList[name] || {};
    var market = checkedSettings.market;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: label + "-" + checkedSettings.i,
      className: _navigationHeader["default"].navProductLink + " " + _navigationHeader["default"].navSubColumnWrap + " " + theme['col-xs-12'] + " " + theme['col-sm-4'] + " " + theme['col-md-3'] + " menu-panel-sub-list-item",
      ref: function ref(el) {
        refList[name][checkedSettings.i] = el;
        return el;
      },
      onKeyUp: function onKeyUp(e) {
        return keyHandler(e, checkedSettings.i, refList[name][checkedSettings.i]);
      },
      role: "menuitem",
      "aria-setsize": setSize,
      "aria-posinset": posInSet,
      "data-menu-item-name": name,
      "data-menu-item-parent-name": checkedSettings.name
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: "" + handleNestedProp(link, 'link.cta.url'),
      onClick: function onClick() {
        return publishMenuClickToDataLayer(checkedSettings.name, handleNestedProp(link, 'link.cta.url'), label, market);
      },
      "data-section": checkedSettings.name,
      "data-linkindex": checkedSettings.i,
      title: label,
      target: checkedLink.cta.openNewTab ? '_blank' : '',
      rel: "noreferrer"
    }, checkedLink.vehicleImage && /*#__PURE__*/_react["default"].createElement(_lazyNavLinkImage["default"], {
      checkedLink: checkedLink
    }), getBackgroundImage(checkedLink, link), /*#__PURE__*/_react["default"].createElement("div", {
      className: _navigationHeader["default"].navLinkInfo
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: _navigationHeader["default"].navLinkLabel + " " + theme.navCarSelector
    }, label), enableProductsRatingStars && /*#__PURE__*/_react["default"].createElement("div", {
      className: _navigationHeader["default"].feefoWrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "feefo-product-stars-widget",
      "data-product-sku": productSkuId
    })), checkedLink.price ? /*#__PURE__*/_react["default"].createElement("p", {
      className: _navigationHeader["default"].navLinkPrice + " " + theme.bodyCopy
    }, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
      format: "price",
      options: {
        value: handleNestedProp(checkedLink, 'checkedLink.price.value'),
        currency: handleNestedProp(config, 'config.currencyFormat'),
        locale: handleNestedProp(config, 'config.localeCode'),
        displayValue: handleNestedProp(checkedLink, 'checkedLink.price.displayValue'),
        zeroMessage: handleNestedProp(checkedLink, 'checkedLink.price.zeroMessage')
      },
      addPriceDisclaimer: handleNestedProp(checkedSettings, 'checkedSettings.addPriceDisclaimer'),
      priceDisclaimerId: checkDisclaimerID(checkedSettings),
      disclaimerData: checkedSettings.disclaimerData
    })) : config.market === 'language-masters' && /*#__PURE__*/_react["default"].createElement("p", {
      className: _navigationHeader["default"].navLinkPrice + " " + theme.bodyCopy
    }, "From $XX,XXX.XX")), (link == null ? void 0 : link.vehicleLabel) && /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _navigationHeader["default"].navLabel
    }, link.vehicleLabel)));
  };
  return !isEmptyArray(products) && products !== ' ' && /*#__PURE__*/_react["default"].createElement("ul", {
    className: _navigationHeader["default"].navLinkList + " " + theme.row
  }, products.map(function (link, i) {
    return renderProductLink({
      link: link,
      i: i,
      totalSetSize: totalSetSize,
      name: name,
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      disclaimerData: disclaimerData,
      market: market
    });
  }));
};
ProductLinks.displayName = 'ProductLinks';
ProductLinks.defaultProps = {
  products: []
};
var _default = exports["default"] = ProductLinks;